export default "__VITE_ASSET__ff4ca89c__"